import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const contractTypeEnum = createEnum({
    PURCHASE_CONTRACT: ['purchase-contract', '采购合同', 'blue'],
    DOMESTIC_PURCHASE_CONTRACT: [
        'domestic-purchase-contract',
        '内贸采购合同',
        'green',
    ],
    DOMESTIC_SALE_CONTRACT: ['domestic-sale-contract', '内贸销售合同', 'cyan'],
    FOREIGN_PURCHASE_CONTRACT: [
        'foreign-purchase-contract',
        '外贸采购合同',
        'purple',
    ],
    FOREIGN_SALE_CONTRACT: ['foreign-sale-contract', '外贸销售合同', 'magenta'],
});
export const CONTRACT_TYPES = enumValues(contractTypeEnum);
export const CONTRACT_TYPE_LABEL_MAP = enumLabelMap(contractTypeEnum);
export const contractVehicleTypeEnum = createEnum({
    NEW_CAR: ['new_car', '新车', 'green'],
    USED_CAR: ['used_car', '二手车', 'orange'],
});
export const CONTRACT_VEHICLE_TYPES = enumValues(contractVehicleTypeEnum);
export const CONTRACT_VEHICLE_TYPE_LABEL_MAP = enumLabelMap(contractVehicleTypeEnum);
export const contractPurchaseTypeEnum = createEnum({
    STOCK_COLLECTIVE: ['stock_collective', '囤货集采', 'blue'],
    FINANCED_PURCHASE: ['financed_purchase', '配资采购', 'purple'],
    JOINT_PURCHASE: ['joint_purchase', '联合采购', 'cyan'],
    SALES_DRIVEN_PURCHASE: ['sales_driven_purchase', '以销定采', 'green'],
});
export const CONTRACT_PURCHASE_TYPES = enumValues(contractPurchaseTypeEnum);
export const CONTRACT_PURCHASE_TYPE_LABEL_MAP = enumLabelMap(contractPurchaseTypeEnum);
export const contractStatusEnum = createEnum({
    DRAFT: ['draft', '草稿', 'default'],
    REVIEWING: ['reviewing', '审核中', 'processing'],
    REVIEW_REJECTED: ['review_rejected', '审核拒绝', 'red'],
    PENDING_PAYMENT: ['pending_payment', '待付款', 'orange'],
    PARTIAL_PAID: ['partial_paid', '部分付款', 'blue'],
    FULLY_PAID: ['fully_paid', '全部付款', 'cyan'],
    PENDING_RECEIPT: ['pending_receipt', '待回款', 'orange'],
    PARTIAL_RECEIVED: ['partial_received', '部分回款', 'blue'],
    FULLY_RECEIVED: ['fully_received', '全部回款', 'cyan'],
    COMPLETED: ['completed', '已完成', 'green'],
});
export const CONTRACT_STATUSES = enumValues(contractStatusEnum);
export const CONTRACT_STATUS_LABEL_MAP = enumLabelMap(contractStatusEnum);
export const contractPaymentMethodEnum = createEnum({
    FULL_PAYMENT: ['full_payment', '全款支付', 'green'],
    INSTALLMENT_PAYMENT: ['installment_payment', '分批支付', 'blue'],
});
export const CONTRACT_PAYMENT_METHODS = enumValues(contractPaymentMethodEnum);
export const CONTRACT_PAYMENT_METHOD_LABEL_MAP = enumLabelMap(contractPaymentMethodEnum);
export const contractClausePermissionEnum = createEnum({
    ALLOW: ['允许', '允许', 'green'],
    DISALLOW: ['不允许', '不允许', 'red'],
});
export const CONTRACT_CLAUSE_PERMISSIONS = enumValues(contractClausePermissionEnum);
export const CONTRACT_CLAUSE_PERMISSION_LABEL_MAP = enumLabelMap(contractClausePermissionEnum);
export const contractInsurancePurchasePartyEnum = createEnum({
    BUYER: ['由买方购买', '由买方购买', 'blue'],
    SELLER: ['由卖方购买', '由卖方购买', 'green'],
});
export const CONTRACT_INSURANCE_PURCHASE_PARTIES = enumValues(contractInsurancePurchasePartyEnum);
export const CONTRACT_INSURANCE_PURCHASE_PARTY_LABEL_MAP = enumLabelMap(contractInsurancePurchasePartyEnum);
export const contractPackingMethodEnum = createEnum({
    NAKED: ['裸装', '裸装', 'default'],
    RO_RO_PALLET: ['滚装盘', '滚装盘', 'orange'],
    CONTAINER: ['集装箱', '集装箱', 'blue'],
});
export const CONTRACT_PACKING_METHODS = enumValues(contractPackingMethodEnum);
export const CONTRACT_PACKING_METHOD_LABEL_MAP = enumLabelMap(contractPackingMethodEnum);
export const serviceContractTypeEnum = createEnum({
    INTERMEDIARY: ['intermediary', '居间合同', 'blue'],
    GUARANTEE: ['guarantee', '担保合同', 'purple'],
    WAREHOUSE_COOPERATION: ['warehouse_cooperation', '仓储合作协议', 'cyan'],
    LOGISTICS_FRAMEWORK: ['logistics_framework', '物流框架协议', 'geekblue'],
    CUSTOMS_AGENCY: ['customs_agency', '代理报关协议', 'orange'],
    OTHER: ['other', '其他服务协议', 'default'],
});
export const SERVICE_CONTRACT_TYPES = enumValues(serviceContractTypeEnum);
export const SERVICE_CONTRACT_TYPE_LABEL_MAP = enumLabelMap(serviceContractTypeEnum);
export const serviceContractValidStatusEnum = createEnum({
    VALID: ['valid', '有效', 'success'],
    TERMINATED: ['terminated', '终止', 'default'],
    EXPIRED: ['expired', '过期', 'error'],
});
export const SERVICE_CONTRACT_VALID_STATUSES = enumValues(serviceContractValidStatusEnum);
export const SERVICE_CONTRACT_VALID_STATUS_LABEL_MAP = enumLabelMap(serviceContractValidStatusEnum);
export const serviceContractAttachmentTypeEnum = createEnum({
    CONTRACT: ['contract', '合同附件', 'blue'],
    INVOICE: ['invoice', '发票', 'cyan'],
});
export const SERVICE_CONTRACT_ATTACHMENT_TYPES = enumValues(serviceContractAttachmentTypeEnum);
export const SERVICE_CONTRACT_ATTACHMENT_TYPE_LABEL_MAP = enumLabelMap(serviceContractAttachmentTypeEnum);
//# sourceMappingURL=contract.js.map